import React from 'react'

function PaintsCoatings() {
  return (
    <div>PaintsCoatings</div>
  )
}

export default PaintsCoatings